import { isIngotItemId } from '../../utils/ingotPlatingUtils';
import { isSocketStoneOtherId } from '../../utils/buttonClickSound';
import {
  EFSUN_OPEN_TOOL_ID,
  EFSUN_REROLL_TOOL_ID,
  EFSUN_CUBE_TOOL_ID,
  getEfsunKindForInventoryType,
  getEfsunKindForSlotType,
  isWeaponEfsunBlocked,
} from '../../utils/armorEfsunUtils';

export const getEfsunToolForOther = (baseItemId) => {
  if (Number(baseItemId) === EFSUN_OPEN_TOOL_ID) return 'open';
  if (Number(baseItemId) === EFSUN_REROLL_TOOL_ID) return 'reroll';
  if (Number(baseItemId) === EFSUN_CUBE_TOOL_ID) return 'cube';
  return null;
};

export const getEfsunTargetKindForGridItem = (item) => {
  if (!item || isWeaponEfsunBlocked(item)) return null;
  return getEfsunKindForInventoryType(item.inventoryType)
    || getEfsunKindForSlotType(item.slotType);
};

export const getIngotIdFromGridItem = (item) => {
  const id = Number(item?.baseItem?.id);
  return isIngotItemId(id) ? id : null;
};

export const POT_STACK_MAX = 200;
export const SOCKET_CLEAN_KIT_ID = 2201;

const potBaseId = (item) => item?.potId ?? item?.baseItem?.id;

export const resolveSpecialDropBetweenItems = (sourceItem, targetItem) => {
  if (!sourceItem || !targetItem?.id) return null;

  // Aynı potun iki yığını: kaynak hedefin üstüne birleşir (taşınmaz, depoya gitmez).
  if (
    sourceItem.inventoryType === 'pots' && targetItem.inventoryType === 'pots'
    && sourceItem.id !== targetItem.id && potBaseId(sourceItem) === potBaseId(targetItem)
  ) {
    return {
      type: 'mergePots',
      sourceId: sourceItem.id,
      targetId: targetItem.id,
      targetFull: (targetItem.count || 1) >= POT_STACK_MAX,
    };
  }

  // Soket taşı silah/zırhın üstüne bırakılırsa ilk boş sokete takılır;
  // Taş Temizleme Kiti bırakılırsa tüm soketler temizlenir (kırık taş = -1 de dolu sayılır).
  const sourceOtherId = Number(sourceItem.baseItem?.id ?? sourceItem.otherId);
  const isStone = sourceItem.inventoryType === 'others' && isSocketStoneOtherId(sourceOtherId);
  const isCleanKit = sourceItem.inventoryType === 'others' && sourceOtherId === SOCKET_CLEAN_KIT_ID;
  if ((isStone || isCleanKit) && (targetItem.inventoryType === 'weapons' || targetItem.inventoryType === 'armors')) {
    const count = targetItem.socketCount || 0;
    const filled = (targetItem.sockets || []).slice(0, count).filter((x) => x !== 0).length;
    return {
      type: isCleanKit ? 'socketClear' : 'socketStone',
      itemType: targetItem.inventoryType === 'weapons' ? 'weapon' : 'armor',
      userItemId: targetItem.id,
      otherId: sourceOtherId,
      noSocket: count <= 0,
      full: !isCleanKit && count > 0 && filled >= count,
      empty: isCleanKit && count > 0 && filled === 0,
    };
  }

  const targetKind = getEfsunTargetKindForGridItem(targetItem);
  if (!targetKind) return null;

  const tool = getEfsunToolForOther(sourceItem.baseItem?.id);
  if (tool) {
    return {
      type: 'efsun',
      targetKind,
      userItemId: targetItem.id,
      tool,
    };
  }

  const ingotOtherItemId = getIngotIdFromGridItem(sourceItem);
  if (ingotOtherItemId) {
    return {
      type: 'plating',
      targetKind,
      userItemId: targetItem.id,
      ingotOtherItemId,
    };
  }

  return null;
};

export const resolveSpecialGridDrop = ({ sourceIndex, targetIndex, gridSlots }) => {
  if (sourceIndex === null || targetIndex === null || sourceIndex === targetIndex) return null;
  const sourceItem = gridSlots[sourceIndex];
  const targetItem = gridSlots[targetIndex];
  return resolveSpecialDropBetweenItems(sourceItem, targetItem);
};

export const isSpecialGridDropAllowed = (args) => {
  const drop = resolveSpecialGridDrop(args);
  return !!drop && !(drop.noSocket || drop.full || drop.empty);
};
